export default "__VITE_ASSET__B9xuZGg0__"